import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
// img
import CtaImg from "../../images/cta-img.png";

export default function Cta() {
    return (
        <>
            <section className='section cta-section'>
                <Container>
                    <Row>
                        <Col md={12}>
                            <div className="cta-card bg-soft-primary">
                                <Row className='justify-content-center'>
                                    <Col lg={7}>
                                        <div className='cta-content'>
                                            <h1 className='fw-semibold text-primary display-5 text-shadow mb-5'>Subscribe to get the latest news for you! </h1>
                                            <Form >
                                                <Form.Group className='cta-input' controlId="exampleForm.ControlInput1">
                                                    <Button variant="primary cta-input-btn" type="submit"><i className="bi bi-send"></i> <span className='ms-2 d-none d-md-inline-block'>Subscribe</span></Button>
                                                    <Form.Control type="email" className='cta-input-control' placeholder="Email address" required />
                                                </Form.Group>
                                            </Form>
                                        </div>
                                    </Col>
                                    <Col sm={8} lg={5}>
                                        <div className='cta-right-content'>
                                            <img src={CtaImg} alt="" className='img-fluid cta-img' />
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}
